import { BUTTON_TYPES, INSERT_PLUGIN_BUTTONS, TOOLBARS } from 'wix-rich-content-editor-common';
import { htmlButtonsTypes, defaults, adsenseDefaults } from '../defaults.js';
import InsertPluginIcon from '../icons/InsertPluginIcon.js';
import Adsense from '../icons/Adsense.js';
import 'react';

const createInsertButtons = ({
  helpers,
  t,
  settings
}) => {
  var _a, _b;
  const { exposeButtons = [htmlButtonsTypes.html], siteDomain } = settings;
  const icon = ((_b = (_a = settings == null ? void 0 : settings.toolbar) == null ? void 0 : _a.icons) == null ? void 0 : _b.InsertPluginButtonIcon) || InsertPluginIcon;
  const index = exposeButtons.indexOf(htmlButtonsTypes.adsense);
  if (!siteDomain && index > -1) {
    exposeButtons.splice(index, 1);
  }
  const buttonsMap = {
    [htmlButtonsTypes.html]: {
      type: BUTTON_TYPES.BUTTON,
      name: INSERT_PLUGIN_BUTTONS.HTML,
      helpers,
      toolbars: [TOOLBARS.INSERT_PLUGIN, TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE],
      tooltip: t("HtmlPlugin_InsertButton_Tooltip"),
      getIcon: () => icon,
      componentData: defaults(false)
    },
    [htmlButtonsTypes.adsense]: {
      type: BUTTON_TYPES.BUTTON,
      name: INSERT_PLUGIN_BUTTONS.ADSENSE,
      componentData: adsenseDefaults(),
      helpers,
      toolbars: [TOOLBARS.INSERT_PLUGIN, TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE],
      section: "BlockToolbar_Section_Embed_Anywhere",
      tooltip: t("AdSensePlugin_InsertButton_Tooltip"),
      getIcon: () => Adsense
    }
  };
  return exposeButtons.map((buttonType) => buttonsMap[buttonType]);
};

export { createInsertButtons as default };
//# sourceMappingURL=insert-buttons.js.map
